import styled from 'styled-components';
import { Delete } from 'ui/icons/action/Delete';
import { colors } from 'ui/theme/colors';
import { GhostButton } from 'ui/button';
import { useRemoveClause } from '../hooks/form';

export const DeleteWrapper = styled.div`
  display: none;
  justify-content: end;
  height: 0;
`;

const DeleteClauseIcon = styled(Delete)`
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.primaryColors.red100};
  border-radius: 50%;
  padding: ${({ theme }) => theme.spacing.values.eighth};
`;

const StyledGhostButton = styled(GhostButton)`
  left: ${({ theme }) => theme.spacing.utils.pxToRem(25)};
  top: ${({ theme }) => theme.spacing.utils.pxToRem(-15)};
  width: fit-content;

  && {
    color: ${colors.white};

    svg:not(.shape) path {
      stroke: ${colors.white};
    }
    svg.shape {
      color: ${colors.white};
    }

    :focus {
      :before {
        border-color: transparent;
      }
    }

    :hover {
      background: transparent;
      color: ${colors.white};

      svg:not(.shape) path {
        stroke: ${colors.white};
      }
      svg.shape {
        color: ${colors.white};
      }
    }
  }
`;

export const DeleteClauseButton = () => {
  const onDelete = useRemoveClause();
  return (
    <DeleteWrapper>
      <StyledGhostButton onClick={onDelete}>
        <DeleteClauseIcon />
      </StyledGhostButton>
    </DeleteWrapper>
  );
};
